import { put, takeEvery } from "redux-saga/effects"
import { axiosPut, get, post } from "helpers/api_helper"
import {
  showSavingModal,
  hideSavingModal,
  setIsOutdated,
  putMenuItemSuccess,
  setSelectedFeature,
} from "../actions"
import {
  addEventInfoFailed,
  addEventInfoSuccess,
  getEventInfoFailed,
  getEventInfoListFailed,
  getEventInfoListSuccess,
  getEventInfoSuccess,
  getRsvpBookedSpotsFailed,
  getRsvpBookedSpotsSuccess,
  getRsvpWebpageConfigFailed,
  getRsvpWebpageConfigSuccess,
  updateEventInfoFailed,
  updateEventInfoSuccess,
} from "./actions"
import {
  ADD_EVENT_INFO,
  GET_EVENT_INFO,
  GET_EVENT_INFO_LIST,
  GET_RSVP_BOOKED_SPOTS,
  GET_RSVP_WEBPAGE_CONFIG,
  UPDATE_EVENT_INFO,
} from "./actionTypes"

function* addEventInfo({ payload: params }) {
  try {
    yield put(showSavingModal())
    const response = yield post("/event-info", params)
    yield put(addEventInfoSuccess(response))
    const menuItem = yield axiosPut("/admin/menu-item", {
      entity_id: response.id,
      menu_item_id: response.menu_item_id,
    })
    yield put(putMenuItemSuccess(menuItem))
    yield put(setSelectedFeature(menuItem))
    yield put(setIsOutdated(true))
    yield put(hideSavingModal())
  } catch (error) {
    yield put(addEventInfoFailed(error))
  }
}

function* getEventInfo({ payload: params }) {
  try {
    const response = yield get(`/event-info/${params}`)
    yield put(getEventInfoSuccess(response))
  } catch (error) {
    yield put(getEventInfoFailed(error))
  }
}

function* updateEventInfo({ payload: params }) {
  try {
    yield put(showSavingModal())
    yield axiosPut(`/event-info/${params.id}`, params)
    yield put(updateEventInfoSuccess())
    yield put(setIsOutdated(true))
    yield put(hideSavingModal())
  } catch (error) {
    yield put(updateEventInfoFailed(error))
  }
}

function* getRsvpWebpageConfig({ payload: params }) {
  try {
    const response = yield get(`/rsvp-webpage-configs/${params?.id}`)
    yield put(getRsvpWebpageConfigSuccess(response))
  } catch (error) {
    yield put(getRsvpWebpageConfigFailed(error))
  }
}

function* getRsvpBookedSpots({ payload: params }) {
  try {
    const response = yield get("/admin/rsvp-booked-spots", { params })
    yield put(getRsvpBookedSpotsSuccess(response))
  } catch (error) {
    yield put(getRsvpBookedSpotsFailed(error))
  }
}

function* getEventInfoList({ payload: params }) {
  try {
    const response = yield get("/event-info", { params })
    yield put(getEventInfoListSuccess(response))
  } catch (error) {
    yield put(getEventInfoListFailed(error))
  }
}

function* eventInfoSaga() {
  yield takeEvery(ADD_EVENT_INFO, addEventInfo)
  yield takeEvery(GET_EVENT_INFO, getEventInfo)
  yield takeEvery(UPDATE_EVENT_INFO, updateEventInfo)
  yield takeEvery(GET_RSVP_BOOKED_SPOTS, getRsvpBookedSpots)
  yield takeEvery(GET_RSVP_WEBPAGE_CONFIG, getRsvpWebpageConfig)
  yield takeEvery(GET_EVENT_INFO_LIST, getEventInfoList)
}

export default eventInfoSaga
